import {makeStyles} from '@material-ui/core';
import {tipografia, colores, links} from '../../../AppStyle';

export const customStyle = makeStyles ({

    footerContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    footerGrid: {
        width: '100%',
        padding: '2rem 0.5rem 2rem 0.5rem',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: colores.escalaGrises.cien
    },
    footerGridEmpty: {
        width: '100%',
        height: '275px',
        paddingLeft: '5rem',
        paddingRight: '5rem',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: colores.escalaGrises.cien
    },
    footerGridWrapper: {
        display: 'flex'
    },
    footerGridWrapperPhone: {
        flexDirection: 'column'
    },
    bottomSectionWrap: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        margin: '40px auto 40px auto'
    },
    bottomSectionWrapPhone: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '90%',
        margin: '40px auto 40px auto',
        flexDirection: 'column'
    },
    bottomSectionLogos: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '10%'
    },
    bottomSectionLogosPhone: {
        display: 'inline-block',
        width: '90%'
    },
    websiteRightsWrapper: {
        margin: '0 10% 0 0'
    },
    websiteRightsWrapperPhone: {
        alignSelf: 'center',
        marginTop: '5%'
    },
    jaLogo: {
       margin: 'auto 12.5px',
       alignSelf: 'center'
    },
    jaLogoMock: {
        marginRight: '20px',
        width: '100%',
        height: '150px'
     },
    jaLogoPhone: {
        margin: '5px',
        height: '60px',
        display: 'inline-flex'
    },
    jaLogoPhoneMock: {
        marginRight: '25px',
        height: '100px'
     },
    websiteRights: {
        color: 'rgb(0, 0, 0)',
        fontSize: '12px',
        marginLeft: '5px',
        marginRight: '5px',
        cursor: 'pointer',
        fontFamily: tipografia.regular,
        textDecoration: 'none',
        '&:hover':{
            textDecoration: 'underline',
        },
        '&:focus':{
            textDecoration: 'underline',
            outline: 'none'
        }
    },
    footerMainColumn:{
        margin: '20px',
        maxWidth: '350px'
    },
    footerColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flexStart',
        margin: '16px',
        textAlign: 'left',
        boxSizing: 'border-box'  
    },
    footerList :{
        listStyleType: 'none'
    },
    footerRrssItemsWrapper:{
        display: 'flex',
        flexDirection: 'row'
    },
    colFooterTittle: {
        fontFamily: tipografia.regular,
        fontWeight: '700',
        fontStyle: 'normal',
        fontSize: '22px',
        lineHeight: '24px',
        color: colores.escalaGrises.cero,
        marginBottom: '20px',
        cursor: 'default'
    },
    colFooter: {
        fontFamily: tipografia.regular,
        fontWeight: '400',
        fontStyle: 'normal',
        fontSize: '15px',
        lineHeight: '24px',
        color: colores.escalaGrises.cero + " !important",
        textDecoration: 'none',
        marginBottom: '15px',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        },
        '&:focus': {
            textDecoration: 'underline',
            outline: 'none'   
        },
    },
    colFooterRRSS: {
        fontFamily: tipografia.regular,
        fontWeight: '400',
        fontStyle: 'normal',
        fontSize: '15px',
        lineHeight: '24px',
        color: colores.escalaGrises.cero,
        textDecoration: 'none',
        marginBottom: '15px',
        cursor: 'pointer',
        '&:focus': {
            border: '1px solid white' ,
            outline: 'none'
        },
    },
    footerColumnLi: {
        color: colores.escalaGrises.cero,
        textDecoration: 'none',
        marginBottom: '15px',
        cursor: 'pointer'
    },
    rrssIcons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginRight: '25px',
        alignItems: 'center',
        fill: colores.escalaGrises.cero,
        width: '20px',
        paddingTop: '2px',
        '&:hover': {
            outline: 'white solid 1px'
        },
    },
    liStyle: {
        listStyleType: 'none'
    },
    gridFooter: {
        width: '100%',
        padding: '2rem 0.5rem 2rem 0.5rem',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: colores.escalaGrises.cien
    },
    bottomSection: {
        width: '100%',
        background: colores.escalaGrises.diez
    },
    classLinkFooter: {
        ...links
    },
    gridWrapper: {
        display: 'flex'
    },
    gridColFooter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '16px',
        textAlign: 'left',
        boxSizing: 'border-box'
    },
    bottomSecctionWrapp: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '90%',
        margin: '40px auto 40px auto',
    }
});  